import * as React from 'react';
import {Panel, FormControl, FormGroup, Navbar, Button, Table} from "react-bootstrap";
import {withRouter} from "react-router";
import {GlobalState} from "../reduxSetting";
import {connect} from "react-redux";
import {renderPath} from "./utils";
import {FrameMeta} from "../problem-domain/frame";
import {Link} from "react-router-dom";
import {pathToLinks} from "../tagUtils";


export class SearchResult extends React.Component<SearchResult.Props, {}> {
    static findMatchedFrames(index: FrameMeta, basePath: string[],
                             keyword: string): string[][] {
        const result: string[][] = [];
        if (index.name &&
            index.name.toLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
            result.push([...basePath, index.name]);
        }
        for (let sub_frame of index.sub_frames) {
            result.push(...SearchResult.findMatchedFrames(
                sub_frame,
                index.name ? [...basePath, index.name] : [...basePath],
                keyword));
        }
        return result;
    }

    static findMatchedLexicons(index: FrameMeta, basePath: string[],
                               keyword: string): string[][] {
        const result: string[][] = [];
        for (let lexicon of index.lexicons) {
            let lexiconStripped = lexicon.replace(".tag", "");
            if (lexiconStripped.indexOf(keyword) >= 0) {
                result.push([...basePath, lexiconStripped]);
            }
        }
        for (let sub_frame of index.sub_frames) {
            result.push(...SearchResult.findMatchedLexicons(
                sub_frame,
                [...basePath, sub_frame.name],
                keyword));
        }
        return result;
    }

    renderMatchedFrames() {
        const matched = SearchResult.findMatchedFrames(this.props.frameIndex, [], this.props.keyword);
        if (matched.length) {
            return (
                <div className="search-result">
                    <h2> Matched Frame:</h2>
                    <Table striped bordered condensed hover>
                        <thead>
                        <tr>
                            <th> Name</th>
                            <th> Path</th>
                        </tr>
                        </thead>
                        <tbody>
                        {matched.map(x => SearchResult.renderRow(
                            x, this.props.frameIndex, false))}
                        </tbody>
                    </Table>
                </div>
            );
        } else {
            return undefined;
        }
    }

    static renderRow(path: string[], frameIndex: FrameMeta, isLexicon: boolean) {
        const lexicon = path.slice(-1)[0];
        const link: string = pathToLinks(path, frameIndex, isLexicon).slice(-1)[0].link || "";
        return <tr>
            <td><Link to={link}>{lexicon}</Link></td>
            <td>{renderPath(path, frameIndex, isLexicon)}</td>
            {isLexicon &&
            <td>{frameIndex.findLexiconMeta(path)!.frequency}</td>}
        </tr>
    }

    renderMatchedLexicons() {
        const matched = SearchResult.findMatchedLexicons(this.props.frameIndex, [], this.props.keyword);
        if (matched.length) {
            return (
                <div className="search-result">
                    <h2> Matched Lexicons:</h2>
                    <Table striped bordered condensed hover>
                        <thead>
                        <tr>
                            <th> Name</th>
                            <th> Path</th>
                        </tr>
                        </thead>
                        <tbody>
                        {matched.map(x => SearchResult.renderRow(x, this.props.frameIndex, true))}
                        </tbody>
                    </Table>
                </div>
            );
        } else {
            return undefined;
        }
    }


    render() {
        return (<Panel>
                <div className="search-result">
                    <h1>Search: {this.props.keyword}</h1>
                    {this.renderMatchedFrames()}
                    {this.renderMatchedLexicons()}
                </div>
            </Panel>
        );
    }
}

export namespace SearchResult {
    export interface Props {
        frameIndex: FrameMeta;
        keyword: string;
    }

    export function mapStateToProps(state: GlobalState, ownProps): SearchResult.Props {
        return {
            frameIndex: FrameMeta.wrapTop(state.index.frames),
            keyword: ownProps.keyword
        }
    }
}

const SearchResultRedux = connect(
    SearchResult.mapStateToProps,
    dispatch => ({})
)(SearchResult);


export function renderSearchResultWithRoute({location}) {
    const keyword = decodeURI(location.pathname.replace("/search/", ""));
    return <SearchResultRedux keyword={keyword}/>
}

export class SearchBox extends React.Component<{ history: any }, {}> {
    private content = "";

    constructor(props) {
        super(props);
    }

    handleChange(event) {
        this.content = event.target.value;
    }

    handleSubmit(event) {
        if (this.content) {
            this.props.history.push(`/search/${encodeURI(this.content)}`);
        }
        event.preventDefault();
    }

    render() {
        return <Navbar.Collapse>
            <Navbar.Form pullRight>
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <FormGroup>
                        <FormControl type="text"
                                     className="input-navi"
                                     placeholder="Input frame or verb"
                                     onChange={this.handleChange.bind(this)}/>
                    </FormGroup>
                    <Button type="submit" className="btn-navi">Search</Button>
                </form>
            </Navbar.Form>
        </Navbar.Collapse>;
    }
}

export const SearchBoxWithRouter = (withRouter(SearchBox as any) as any);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/search.tsx